// extracted by mini-css-extract-plugin
export default {"root":"Wallet_root__qgx7a","wallet":"Wallet_wallet__TLGzZ","title":"Wallet_title__mQM7w","desc":"Wallet_desc__L-gkO","cond":"Wallet_cond__H2K-v"};